/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActiveSeasonRow } from './ActiveSeasonRow';
import {
    ActiveSeasonRowFromJSON,
    ActiveSeasonRowFromJSONTyped,
    ActiveSeasonRowToJSON,
    ActiveSeasonRowToJSONTyped,
} from './ActiveSeasonRow';

/**
 * 
 * @export
 * @interface WidgetDataActiveSeasonsWidgetData
 */
export interface WidgetDataActiveSeasonsWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataActiveSeasonsWidgetData
     */
    $type?: WidgetDataActiveSeasonsWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<ActiveSeasonRow>}
     * @memberof WidgetDataActiveSeasonsWidgetData
     */
    items: Array<ActiveSeasonRow>;
}


/**
 * @export
 */
export const WidgetDataActiveSeasonsWidgetDataTypeEnum = {
    ActiveSeasons: 'active-seasons'
} as const;
export type WidgetDataActiveSeasonsWidgetDataTypeEnum = typeof WidgetDataActiveSeasonsWidgetDataTypeEnum[keyof typeof WidgetDataActiveSeasonsWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataActiveSeasonsWidgetData interface.
 */
export function instanceOfWidgetDataActiveSeasonsWidgetData(value: object): value is WidgetDataActiveSeasonsWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataActiveSeasonsWidgetDataFromJSON(json: any): WidgetDataActiveSeasonsWidgetData {
    return WidgetDataActiveSeasonsWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataActiveSeasonsWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataActiveSeasonsWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(ActiveSeasonRowFromJSON)),
    };
}

export function WidgetDataActiveSeasonsWidgetDataToJSON(json: any): WidgetDataActiveSeasonsWidgetData {
    return WidgetDataActiveSeasonsWidgetDataToJSONTyped(json, false);
}

export function WidgetDataActiveSeasonsWidgetDataToJSONTyped(value?: WidgetDataActiveSeasonsWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(ActiveSeasonRowToJSON)),
    };
}

